import {newModalFromString} from './components/modal';

class ProfileEnrich {
    init () {
        this.initOutsideClickHandler();
        this.initNextButton();
        this.initPrevButton();
        this.enableNextButton();
        this.initCheckboxes();
        this.initFavouriteStore();
        this.initInputStore();
        this.initInputChildren();
        this.enableTabButton();
    }

    initInputChildren () {
        $('.step-container.step_4 input[name="TEZ0300"], input[name="TEZ0301"], input[name="TEZ0302"], input[name="TEZ0303"], input[name="TEZ0304"]').on('click', function (e) {
            var $childrenElement = $('.step-container.step_4 input[name="TEZ0302"]');
            $('.js-children-number').toggleClass('hidden', !$childrenElement.prop('checked'));
            if ($('input[name="TEZ0302"]:checked').length > 0) {
                $('.js-children-number').removeClass('hidden');
            }
        });
    }

    initInputStore () {
        $('.step-container.step_5 input[name="TEZ0500"], input[name="TEZ0501"]').on('click', function (e) {
            var yes = 'TEZ0500';
            var $currentInput = $(e.currentTarget);
            var $otherInput = $('.step-container.step_5 input').not($currentInput);

            if ($currentInput.prop('checked')) {
                $otherInput.prop('checked', false);
            }

            if ($(e.currentTarget).val() === yes) {
                if ($('#customerHasStore').val() === 'true') {
                    $('.js-pre-store-locator-btn').trigger('click');
                } else {
                    $('.js-pre-store-locator-section').removeClass('hidden');
                }
            } else {
                $('.js-pre-store-locator-section').addClass('hidden');
            }
            if ($('.mapping-container').attr('data-step') === 'step_5' && $('.step-container.step_5 input[name="TEZ0500"]').prop('checked') && $('.store-result.storeChosen').length === 0) {
                $('.js-proceed-next-step').prop('disabled', true);
                $('.js-proceed-last-step').prop('disabled', true);
            }
        });

        $('.js-pre-store-locator-btn').on('click', function (e) {
            $(this).closest('.js-pre-store-locator-section').addClass('hidden');
            $(this).closest('.cc-main-category').find('.cc-enrich-section__choices').removeClass('hidden');
            $('.js-store-locator-section').removeClass('hidden');
        });
    }

    initFavouriteStore () {
        $('.cc-enrich').on('click', '.store-result', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.store-result').removeClass('storeChosen');
            $(e.currentTarget).addClass('storeChosen');
            $('.js-proceed-next-step').prop('disabled', false);
            $('.js-proceed-last-step').prop('disabled', false);
        });
    }

    initOutsideClickHandler () {
        if ($('.page').data('action') !== 'Account-EnrichForm') {
            return;
        }
        var elementsSelector = '.account-navigation, header, footer, .user-logout-link';
        var _self = this;

        $(elementsSelector).on('click', function (e) {
            var clickedElement = $(e.target);
            var $isOutsideClicked = $('#isOutsideClicked');
            if ($isOutsideClicked.val() === 'false') {
                e.preventDefault();
                $isOutsideClicked.val('true');
                _self.openExitModal(clickedElement);
            }
        });
    }

    initNextButton () {
        var _self = this;
        $('input').on('change', function (e) {
            if ($(e.target).attr('name') !== 'TEZ0500') {
                _self.enableNextButton();
            }
        });
        $('.js-proceed-next-step').on('click', function (e) {
            var currentStep = $(e.currentTarget).attr('data-step');
            var formData = {};
            var checkboxesChecked = $('.step-container.' + currentStep + ' input[type="checkbox"]:checked');
            var preferences = [];
            var analyticsData = [];

            checkboxesChecked.each(function () {
                preferences.push($(this).val());
                analyticsData.push($(this).attr('data-analytics'));
            });
            formData.preferences = preferences.join(',');
            formData.isLastStep = _self.isLastStep() || _self.isFinalEditStep();
            if (_self.getCurrentStep() === 'step_5' && $('.storeChosen').length > 0 && $('input[name="TEZ0500"]').prop('checked')) {
                formData.favouriteStore = $('.storeChosen').attr('id');
            }
            _self.callSavePreference(formData);
            _self.applyDependences(preferences);

            $('body').trigger('analytics:profileEnrich', {
                step: currentStep,
                preferences: analyticsData});
            window.scrollTo(0, 0);
            if (currentStep === 'step_1' && $('.step_2 .tabs .js-tab-link:not(.inactive)').length > 0) {
                $('.step_2 .tabs .js-tab-link:not(.inactive)').eq(0).trigger('click');
            }
        });

        if (_self.getCurrentStep() === 'step_2' && $('.step_2 .tabs .js-tab-link:not(.inactive)').length > 0) {
            $('.step_2 .tabs .js-tab-link:not(.inactive)').eq(0).trigger('click');
        }
    }

    enableTabButton () {
        if ($('.tab-content.current').find('input:checked').length < 1) {
            $('.js-proceed-next-tab').prop('disabled', true);
        } else {
            $('.js-proceed-next-tab').prop('disabled', false);
        }
        $('.js-step-section').on('click', function (e) {
            if ($('.tab-content.current').find('input:checked').length < 1) {
                $('.js-proceed-next-tab').prop('disabled', true);
            } else {
                $('.js-proceed-next-tab').prop('disabled', false);
            }
        });
    }

    enableNextButton () {
        var allSectionsValid = true;
        var $mappingContainer = $('.mapping-container');
        var currentStep = $mappingContainer.attr('data-step');
        var sections = $('.step-container.' + currentStep + ' .js-step-section:not(.inactive):not(.js-tab-link):not(.js-step-section-children)');

        if (sections.length > 0) {
            sections.each(function () {
                if ($('.step-container.' + currentStep + ' input[name="TEZ0302"]:checked').length > 0) {
                    $('.js-children-number').removeClass('hidden');
                    if ($('.js-step-section-children input:checked').length === 0) {
                        allSectionsValid = false;
                        return false;
                    }
                } else {
                    var sectionChecked = $(this).find('input:checked').length;
                    if (sectionChecked === 0) {
                        allSectionsValid = false;
                        return false; // Exit the loop if any section is invalid
                    }
                }
            });
        } else {
            var checked = $('.step-container.' + currentStep + ' input:checked').length;
            if (checked === 0) {
                allSectionsValid = false;
            }
        }

        if ($('.mapping-container').attr('data-step') === 'step_5' && $('.step-container.step_5 input[name="TEZ0500"]').prop('checked') && $('.store-result.storeChosen').length === 0) {
            allSectionsValid = false;
        }

        if ($('.step_2 .tabs .js-tab-link:not(.inactive)').length > 0) {
            $('.step_2 .tab-content.d-none').removeClass('d-none');
        }

        if ($('.step-container.' + currentStep + ' input[name="TEZ0500"]:checked').length > 0) {
            $('.js-pre-store-locator-section').addClass('hidden');
            $('.js-store-locator-section').removeClass('hidden');
        }

        if ($('.step-container.' + currentStep + ' input[name="TEZ0501"]:checked').length > 0) {
            $('.js-pre-store-locator-section').addClass('hidden');
            $('.js-store-locator-section').addClass('hidden');
        }

        if (currentStep === 'step_2') {
            var linkDataTab = '';
            $('.js-tab-link.js-step-section:not(.inactive)').each(function () {
                linkDataTab = $(this).attr('data-tab');
                if ($('#' + linkDataTab).find('input:checked').length < 1) {
                    $('.js-proceed-next-step').hide();
                    $('.js-proceed-next-tab').show();
                    return false;
                }
            });
            this.enableTabButton();
            $('.js-proceed-next-tab').on('click', function (e) {
                e.preventDefault();
                $('.js-tab-link.js-step-section.current').removeClass('current');
                $('.tab-content.current').removeClass('current');
                $('.js-tab-link.js-step-section[data-tab=' + linkDataTab + ']').addClass('current');
                $('#' + linkDataTab).addClass('current');
                if ($('.tab-content.current').find('input:checked').length < 1) {
                    $('.js-proceed-next-tab').prop('disabled', true);
                } else {
                    $('.js-proceed-next-tab').prop('disabled', false);
                }
            });
            if (allSectionsValid) {
                $('.js-proceed-next-step').show();
                $('.js-proceed-next-tab').hide();
            }
        } else {
            $('.js-proceed-next-step').show();
        }
        if (allSectionsValid) {
            $('.js-proceed-next-step').prop('disabled', false);
            $('.js-proceed-last-step').prop('disabled', false);
        } else {
            $('.js-proceed-next-step').prop('disabled', true);
            $('.js-proceed-last-step').prop('disabled', true);
        }
    }

    initPrevButton () {
        var _self = this;
        var $mappingContainer = $('.mapping-container');
        var currentStep = $mappingContainer.attr('data-step');
        $('.js-proceed-prev-step').on('click', function (e) {
            _self.moveToPrevStep();
            window.scrollTo(0, 0);
            if (currentStep === 'step_3' && $('.step_2 .tabs .js-tab-link:not(.inactive)').length > 0) {
                $('.step_2 .tabs .js-tab-link:not(.inactive)').first().trigger('click');
            }
        });
    }

    callSavePreference (formData) {
        var _self = this;
        var url = $('#savePreferenceUrl').val();
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    _self.moveToNextStep();
                } else {

                }
            },
            error: function (data) {
                $.spinner().stop();
            }
        });
    }

    moveToNextStep () {
        var lastStep = $('#lastStep').val();
        var $mappingContainer = $('.mapping-container');
        var currentStep = $mappingContainer.attr('data-step');
        var currentStepIndex = parseInt(currentStep.split('_')[1]);
        var nextStepIndex = currentStepIndex + 1;
        var nextStep = 'step_' + nextStepIndex;
        var isFinalEditStep = this.isFinalEditStep();
        if (currentStep === lastStep || isFinalEditStep) {
            this.openFinalModal();
        } else {
            $mappingContainer.attr('data-step', nextStep);
        }
        this.enableNextButton();
    }

    isFinalEditStep () {
        var isProfileEnriched = $('#isProfileEnriched').val() === 'true';
        if (!isProfileEnriched) return false;
        var currentStep = this.getCurrentStep();
        return currentStep !== 'step_1';
    }

    getCurrentStep () {
        return $('.mapping-container').attr('data-step');
    }

    getCurrentStepDependencies () {
        var currentStep = this.getCurrentStep();
        return $('.step-container.' + currentStep).attr('data-dependencies');
    }

    applyDependences (preferences) {
        var dependencies = this.getCurrentStepDependencies();
        var currentStep = this.getCurrentStep();
        var currentStepIndex = parseInt(currentStep.split('_')[1]);
        var nextStepIndex = currentStepIndex + 1;
        var nextStep = 'step_' + nextStepIndex;
        var activeTabSetted = false;
        if (dependencies === undefined || dependencies === '') {
            return;
        }
        var $dependentElements = $('.step-container.' + nextStep + ' .js-step-section');
        $dependentElements.toArray().forEach(element => {
            var dependenciesCodes = $(element).attr('data-dependencies-code');
            if (preferences.indexOf(dependenciesCodes) === -1) {
                $(element).addClass('inactive');
            } else {
                $(element).removeClass('inactive');
                if (!activeTabSetted) {
                    $(element).trigger('click');
                    activeTabSetted = true;
                }
            }
        });

        if (nextStepIndex === 2) {
            $('.step_2 .tabs').removeClass('d-none');

            if ($('.step_2 .tabs .js-tab-link:not(.inactive)').length === 1) {
                $('.step_2 .tabs .js-tab-link:not(.inactive)').trigger('click');
                $('.step_2 .tabs').addClass('d-none');
            }
        }
    }

    moveToPrevStep () {
        var $mappingContainer = $('.mapping-container');
        var currentStep = this.getCurrentStep();
        var currentStepIndex = parseInt(currentStep.split('_')[1]);
        var nextStepIndex = currentStepIndex - 1;
        var nextStep = 'step_' + nextStepIndex;
        $mappingContainer.attr('data-step', nextStep);
        this.enableNextButton();
    }

    initCheckboxes () {
        var checkboxes = $('.js-select-accordion');
        checkboxes.toArray().forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    $(checkbox).parents('.cc-final-sub-main-category-wrp').addClass('cc-active');
                } else {
                    $(checkbox).parents('.cc-final-sub-main-category-wrp').removeClass('cc-active');
                }
            });
        });
    }

    openExitModal (clickedElement) {
        const htmlContent = $('#confirmExitModal').clone().html();
        var modal;
        var $isOutsideClicked = $('#isOutsideClicked');
        const onClose = () => {
            $isOutsideClicked.val('false');
        };
        modal = newModalFromString(htmlContent, false, ['cc-enrich-modal'], null, onClose);
        modal.open();
        $(modal.modalBox)
            .find('.close-button-info')
            .on('click', function () {
                modal.close();
            });
        $(modal.modalBox)
            .find('.js-proceed-exit')
            .on('click', function () {
                $isOutsideClicked.val('true');
                // clickedElement.trigger('click');
                var loyaltyPageUrl = $('#loyaltyPageUrl').val();
                window.location.href = loyaltyPageUrl;
            });
    }

    openFinalModal () {
        const htmlContent = $('#finalModal').clone().html();
        var loyaltyPageUrl = $('#loyaltyPageUrl').val();
        var modal;
        const onClose = () => {
            window.location.href = loyaltyPageUrl;
        };
        modal = newModalFromString(htmlContent, false, ['cc-enrich-modal'], null, onClose);
        modal.open();
        $(modal.modalBox)
            .find('.close-button-info')
            .on('click', function () {
                modal.close();
            });
        $(modal.modalBox)
            .find('.js-proceed-final-step')
            .on('click', function () {
                window.location.href = loyaltyPageUrl;
            });
    }

    isLastStep () {
        var lastStep = $('#lastStep').val();
        var $mappingContainer = $('.mapping-container');
        var currentStep = $mappingContainer.attr('data-step');
        return currentStep === lastStep;
    }
}

const profileEnrich = new ProfileEnrich();
export default profileEnrich;
